module.exports = __webpack_public_path__ + "headset-25180251eaa2684e1ac9.svg";